<template>
	<div>
		<div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				center-active
				height="65"
				active-class="mid-primary"
				color="white"
			>
				<v-tab :to="{ name: 'add-vacation-type' }">
					<!-- <v-icon class="me-1"> mdi-calendar-edit </v-icon> -->
					إعدادات الموظفين
				</v-tab>

				<v-tab :to="{ name: 'add-attendance-type' }">
					<!-- <v-icon class="me-1"> mdi-calendar-edit </v-icon> -->
					إعدادات الدوام
				</v-tab>

				<v-tab :to="{ name: 'add-job-position' }">
					<!-- <v-icon class="me-1"> mdi-calendar-edit </v-icon> -->
					إعدادات إدارية
				</v-tab>

				<v-tab :to="{ name: 'users' }">
					<!-- <v-icon class="me-1"> mdi-calendar-edit </v-icon> -->
					إعدادات المستخدمين
				</v-tab>
				<!-- <v-tab
				
				:to="{ name: 'add-personal-information' }">
				<v-icon
					
					class="me-1">
					mdi-account-plus
				</v-icon>
				{{ $T('tabs.personalInformation') }}
				</v-tab> -->
		
				<!-- <v-tab :to="{ name: 'add-job-position' }">
					<v-icon class="me-1"> mdi-briefcase-account-outline </v-icon>
					{{ $T('tabs.jobPosition') }}
				</v-tab> -->
				<v-tab :to="{ name: 'salaries-settings' }">
					<v-icon class="me-1">mdi-cash-multiple</v-icon>
					{{ $T('tabs.salaries') }}
				</v-tab>
				<v-tab :to="{ name: 'reminders-types' }">
					<v-icon class="me-1">mdi-alarm</v-icon>
					{{ $T('tabs.reminders-types') }}
				</v-tab>
				<v-tab :to="{ name: 'default-table-headers' }">
					<v-icon class="me-1"> mdi-table-cog </v-icon>
					الجداول الافتراضية
				</v-tab>

				<v-tab :to="{ name: 'Leaves' }">
					<v-icon class="me-1"> mdi-calendar-remove </v-icon>
					العطل
				</v-tab>
				<!-- <v-tab
				
				:to="{ name: 'add-allowance-type' }">
				<v-icon
					
					class="me-1">
					mdi-hand-coin-outline
				</v-icon>
				{{ $T('tabs.AllowanceType') }}
			</v-tab> -->
			</v-tabs>
			<v-divider
				vertical
				class="me-1 ms-auto"></v-divider>
			<div
				style="width: 300px"
				class="text-center primary--text px-3">
				{{ $T(`routes.${this.$route.meta.i18nTranslateKey}`) }}
			</div>
		</div>

		<v-divider></v-divider>

		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'Settings',

	data() {
		return {
			tabs: null,
		};
	},
};
</script>
